module.exports = __webpack_public_path__ + "static/media/customer-solution-4.c9d6ff5a.png";